import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessUserPunchCardDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-business-user-punch-card-detail',
  templateUrl: 'business-user-punch-card-detail.html',
})
export class BusinessUserPunchCardDetailPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessUserPunchCardDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-user-punch-card-detail/business-user-punch-card-detail.ts